import { pumaAPI } from "./api"

const baseUrl = "Grids/"

export const isBookmarkGridTile = (
    tile: Api.GridTileDTO,
): tile is Api.BookmarkGridTileDTO => {
    return (
        tile.Type === "BookmarkGridTile" &&
        (tile as Api.BookmarkGridTileDTO).BookmarkId !== undefined
    )
}

export const isShortcutGridTile = (
    tile: Api.GridTileDTO,
): tile is Api.ShortcutGridTileDTO => {
    return (
        tile.Type === "ShortcutGridTile" &&
        (tile as Api.ShortcutGridTileDTO).ShortcutId !== undefined
    )
}

export const isWorkspaceContentGridTile = (
    tile: Api.GridTileDTO,
): tile is Api.WorkspaceContentGridTileDTO =>
    tile.Type === "WorkspaceContentGridTile"

export const isWelcomePageContentGridTile = (
    tile: Api.GridTileDTO,
): tile is Api.WelcomePageContentGridTileDTO =>
    tile.Type === "WelcomePageContentGridTile"

export const getDashboardCoverPageGrid = (
    filter: (tile: Api.GridTileDTO) => boolean,
): Promise<Grids.Grid> =>
    pumaAPI
        .postJSON(`${baseUrl}DashboardCoverPage/GetOrCreate`)
        .then(
            (grid: Api.GridDTO): Promise<Grids.Grid> =>
                parseGridResponse(grid, filter),
        )

export const getWorkspaceCoverPageGrid = (
    workspaceId: number,
    filter: (tile: Api.GridTileDTO) => boolean,
): Promise<Grids.Grid> =>
    pumaAPI
        .postJSON(
            `${baseUrl}WorkspaceCoverPage/GetOrCreate?workspaceId=${workspaceId}`,
        )
        .then(
            (grid: Api.GridDTO): Promise<Grids.Grid> =>
                parseGridResponse(grid, filter),
        )

export const getWelcomePageGrid = (
    filter: (tile: Api.GridTileDTO) => boolean,
): Promise<Grids.Grid> =>
    pumaAPI
        .postJSON(`${baseUrl}WelcomePage/GetOrCreate`)
        .then(
            (grid: Api.GridDTO): Promise<Grids.Grid> =>
                parseGridResponse(grid, filter),
        )

export const updateTilesOrder = (
    gridId: number,
    tileIds: number[],
    filter: (tile: Api.GridTileDTO) => boolean,
): Promise<Grids.Grid> =>
    pumaAPI
        .postJSON(`${baseUrl}UpdateTilesOrder`, {
            GridId: gridId,
            TileIds: tileIds,
        })
        .then(
            (grid: Api.GridDTO): Promise<Grids.Grid> =>
                parseGridResponse(grid, filter),
        )

const parseGridResponse = (
    grid: Api.GridDTO,
    filter: (tile: Api.GridTileDTO) => boolean,
): Promise<Grids.Grid> => {
    let tiles: Grids.GridTile[] = []
    tiles = grid.Tiles.$values.filter(filter).map(convertTileDTO)

    return new Promise<Grids.Grid>((resolve) =>
        resolve({ id: grid.GridId, tiles } as Grids.Grid),
    )
}

const convertTileDTO = (tile: Api.GridTileDTO): Grids.GridTile => {
    if (isBookmarkGridTile(tile)) {
        return {
            id: tile.TileId,
            bookmarkId: tile.BookmarkId,
            type: "Bookmark",
        } as Grids.BookmarkGridTile
    } else if (isShortcutGridTile(tile)) {
        return {
            id: tile.TileId,
            shortcutId: tile.ShortcutId,
            type: "Shortcut",
        } as Grids.ShortcutGridTile
    } else if (isWelcomePageContentGridTile(tile)) {
        return {
            id: tile.TileId,
            type: "WelcomePageContent",
        } as Grids.WelcomePageContentGridTile
    }
    return {
        id: tile.TileId,
        type: "WorkspaceContent",
    } as Grids.WorkspaceContentGridTile
}
